<template>

    <div>
        <Delivery
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.PHARMACY"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <PharmacyTabLinks />
            </template>
        </Delivery>
    </div>

</template>

<script>
    import PharmacyTabLinks from '@/components/pharmacies/PharmacyTabLinks';
    import Delivery from '@/components/delivery/Delivery';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'GrocerDelivery',

        components: {
            Delivery,
            PharmacyTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/pharmacies/${id}`)).data;
        },

        methods: {}
    }
</script>
